exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gpa--header{border:1px solid #000;border-radius:.7rem .7rem 0 0;cursor:pointer;background-color:#a8a8a8;outline:none!important;margin-bottom:2px}.gpa--header:active,.gpa--header:focus,.gpa--header:hover{outline:none!important;background-color:rgba(0,0,0,.1);border-color:orange}.gpa--header>md-icon{cursor:pointer}.active{border-bottom:0!important;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/gpa/gpa.scss
// module id = 468
// module chunks = 0